import React, { useState } from 'react';
import { useAuth } from '../../auth/index';
import axios from 'axios';
import Cookies from 'universal-cookie';
import "./style.css"
import logo from "../../assets/images/white-logo.png"


function Login() {
  const { login } = useAuth();

  const [ username, setUsername ] = useState("")
  const [ password, setPassword ] = useState("")
  const [ errorMsg, setErrorMsg ] = useState("")
  const [ loginLoad, setLoginLoad ] = useState("Log In")


    // Create a cookies instance
    const cookies = new Cookies();

    // Function to set the session token in a cookie
    const setSessionCookie = (token) => {
    cookies.set('sessionToken', token, { path: '/' });
    };

    // Function to set the session token in a cookie
    const setSessionUser = (user) => {
      cookies.set('username', user, { path: '/' });
    };

  const handleLogin = () => {
    setLoginLoad(
      <>
        <span className="loader"></span>
      </>
    )
    // Implement your authentication logic here (e.g., API call, form validation)
    // On successful login, call login() to set the authenticated user.
    const userData = { 
        username: username,
        password: password
     };

    axios.post('https://buckinghammall-admin-auth.eddyspace.com/api/login', userData)
    .then(response => {
        console.log('Response:', response.data);
        login(userData);
        setSessionCookie(response.data.token)
        setSessionUser(response.data.user.username)
        setLoginLoad("Log In")
        
         setTimeout(() => {
           window.location.href = "/"
         }, 200)
    })
    .catch(error => {
        console.error('Error:', error);
        setErrorMsg(error.response.data.message)
    });

  };

  return (
    <>
      <div class="form-background">
        <div className="shape"></div>
        <div className="shape"></div>
      </div>
      <div className='form'>
        <img
          src={logo}
          alt="logo"
          width="162px"
          height="52px"
        />

        <label className="form-label" for="username">Username</label>
        <input 
          type="text" 
          className='form-input'
          placeholder="Username" 
          id="username" 
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <label className="form-label" for="password">Password</label>
        <input 
          className='form-input'
          type="password" 
          placeholder="Password" 
          id="password" 
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <br/>
        <p>{errorMsg}</p>
        <button className='form-button' type='button' onClick={handleLogin}>{loginLoad}</button>
      </div>
    </>
  );
}

function Logout() {
  const { logout } = useAuth();

  const handleLogout = () => {
    // Implement your logout logic here (e.g., clearing tokens, cookies)
    // On logout, call logout() to clear the authenticated user.
    logout();
  };

  return (
    <div>
      <h2>Logout Page</h2>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default Login;